import React, { useState } from 'react'; 
import { timestampToDate, dateToTimestamp } from '../../../../../../Services/timestampCovert'; 
import ModalService from '../../../ModalService/ModalService';
import FormTabuladores from './FormTabuladores';  

const ModalAddTabuladores = ({ openAdd, setOpenAdd, agregar, errorTable, informacionAdicional, nombreModulo }) => {
    
    const [ error, setError ] = useState( null );

    const cerrarModal = () => {
        setOpenAdd( false );
        setError( null );
    }

    const enviarTabulador = tabulador => {
        var timestamp = dateToTimestamp(tabulador.fechaini);
        var date= timestampToDate(timestamp);
        const info = { fechaini:  date, fechafin: '-' };
        agregar(info, timestamp);
        setOpenAdd( false );
    }

    return (
        <ModalService title="Nuevo Tabulador" parentNode={nombreModulo}
            isOpen={ openAdd } onClose={ () => cerrarModal() } >
            <div className="row">
                <div className="col-12">
                    <FormTabuladores
                        enviarTabulador={enviarTabulador}
                        error={error}
                        setError={setError}
                        informacionAdicional={informacionAdicional}
                    />
                </div>
            </div>
        </ModalService>
    );
}

export default ModalAddTabuladores;